// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"69a5e8d8","239":"ad40150f","453":"8701dc61","455":"835a4614"}[chunkId] + ".chunk.js";
};